import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
var Portal = _ref => {
  var {
    children
  } = _ref;
  var takeoverContainer = React.useMemo(() => document.createElement('div'), []);
  useEffect(() => {
    document.body.appendChild(takeoverContainer);
    return () => {
      takeoverContainer.remove();
    };
  });
  return /*#__PURE__*/createPortal(children, document.body);
};
Portal.displayName = 'Portal';
export { Portal };
//# sourceMappingURL=Portal.js.map